import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../../services';

@Component({
  selector: 'mj-language-selector',
  templateUrl: './languageSelector.template.html',
  styleUrls: ['./languageSelector.style.scss'],
})
export class LanguageSelectorComponent {
  constructor(private _translate: TranslateService, public $u: Utils) {}

  public setSelectedLanguage(langCode) {
    this.$u.hide('langDialog');
    this._translate.use(langCode);
    localStorage.setItem('language', langCode);
  }

  public isCurrentLang(langCode) {
    return this._translate.currentLang === langCode;
  }
}
